import { AgentProfileLayout } from './agent-profile-layout';
import { DefaultProfileLayout } from './default-profile-layout';
import { useUserProfileData } from './use-user-profile-data';
import { ProfileSkeleton } from '@/packages/home/components/skeleton';

interface UserProfileProps {
  agentVideoRecommendationActive?: boolean;
}

export const UserProfile = ({
  agentVideoRecommendationActive = false,
}: UserProfileProps) => {
  const { isLoading, ...data } = useUserProfileData();

  if (isLoading) return <ProfileSkeleton />;

  return agentVideoRecommendationActive ? (
    <AgentProfileLayout {...data} />
  ) : (
    <DefaultProfileLayout {...data} />
  );
};
